import axios from 'axios'
import { getFirstErrorMessage, getErrorMessage, getErrorMessages } from '~/lib/axios'
import config from '../lib/config'
const {apiUri} = config.CONFIG
const APIURI = apiUri + '/customer/clubspeed/event-reservation'

export default {
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  async getUnavailability(payload) {
    const {data = {}} = await axios.get(`${APIURI}/unavailability`, {params: payload});
    return data.unavailability;
  },
  async hold(payload) {
    const { data = {} } = await axios.post(`${APIURI}/hold`, payload);
    return data.data || {}
  },
  async unhold({id}) {
    try {
      const { data = {} } = await axios.delete(`${APIURI}/hold/${id}`);
      return data
    } catch (e) {
      //
    }
    return false
  }
}
